module.exports = __webpack_public_path__ + "img/facade.4349fe82.jpg";